import { createSvgIcon } from '@mui/material';

export const ProfileIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M10 10a4.167 4.167 0 1 0 0-8.333A4.167 4.167 0 0 0 10 10Zm-6.667 8.333h13.334a6.667 6.667 0 0 0-13.334 0Z"
    />
  </svg>,
  'ProfileIcon',
);
